<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrows-up`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.52888 3.12635C7.78854 2.8667 8.21058 2.86678 8.47029 3.12635L11.9703 6.62635C12.23 6.88605 12.23 7.30806 11.9703 7.56776C11.7106 7.82734 11.2885 7.82742 11.0289 7.56776L8.66462 5.2035V12.4056C8.66462 12.7729 8.36686 13.0707 7.99959 13.0707C7.63243 13.0706 7.33455 12.7728 7.33455 12.4056V5.2035L4.97029 7.56776C4.71058 7.82734 4.28854 7.82742 4.02888 7.56776C3.76935 7.30809 3.76934 6.88602 4.02888 6.62635L7.52888 3.12635Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowsUp',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
